import { defineMessages } from "react-intl"

export default defineMessages({
  headerAboutYou: {
    id: "app.components.AboutYou.headerAboutYou",
  },
  hasChildren: {
    id: "app.components.AboutYou.hasChildren",
  },
  industryInvolvements: {
    id: "app.components.AboutYou.industryInvolvements",
  },
  'industryInvolvements.Studied': {
    id: "app.components.AboutYou.industryInvolvements.Studied",
  },
  'industryInvolvements.Journalist': {
    id: "app.components.AboutYou.industryInvolvements.Journalist",
  },
  'industryInvolvements.Retail': {
    id: "app.components.AboutYou.industryInvolvements.Retail",
  },
  'industryInvolvements.Competition': {
    id: "app.components.AboutYou.industryInvolvements.Competition",
  },
  'industryInvolvements.MarketingUR': {
    id: "app.components.AboutYou.industryInvolvements.MarketingUR",
  },
  'industryInvolvements.Streamer': {
    id: "app.components.AboutYou.industryInvolvements.Streamer",
  },
  'industryInvolvements.RelatedtoUbi': {
    id: "app.components.AboutYou.industryInvolvements.RelatedtoUbi",
  },
  'industryInvolvements.RelatedtoCompetition': {
    id: "app.components.AboutYou.industryInvolvements.RelatedtoCompetition",
  },
  'industryInvolvements.WorkedatUbi': {
    id: "app.components.AboutYou.industryInvolvements.WorkedatUbi",
  },
  referrals: {
    id: "app.components.AboutYou.referrals",
  },
  'referrals.Facebook': {
    id: "app.components.AboutYou.referrals.Facebook",
  },
  'referrals.Twitter': {
    id: "app.components.AboutYou.referrals.Twitter",
  },
  'referrals.Instagram': {
    id: "app.components.AboutYou.referrals.Instagram",
  },
  'referrals.LinkedIn': {
    id: "app.components.AboutYou.referrals.LinkedIn",
  },
  'referrals.OtherSocialMedia': {
    id: "app.components.AboutYou.referrals.OtherSocialMedia",
  },
  'referrals.Advertisement': {
    id: "app.components.AboutYou.referrals.Advertisement",
  },
  'referrals.UbisoftWebsite': {
    id: "app.components.AboutYou.referrals.UbisoftWebsite",
  },
  'referrals.UbisoftEmail': {
    id: "app.components.AboutYou.referrals.UbisoftEmail",
  },
  'referrals.UbisoftEmployee': {
    id: "app.components.AboutYou.referrals.UbisoftEmployee",
  },
  'referrals.FriendorRelative': {
    id: "app.components.AboutYou.referrals.FriendorRelative",
  },
  'referrals.Event': {
    id: "app.components.AboutYou.referrals.Event",
  },
  'referrals.GamePlaytesterCrew': {
    id: "app.components.AboutYou.referrals.GamePlaytesterCrew",
  },
  'referrals.Other': {
    id: "app.components.AboutYou.referrals.Other",
  },
  referralEmail: {
    id: "app.components.AboutYou.referralEmail",
  },
  referralEmailPlaceholder: {
    id: "app.components.AboutYou.referralEmailPlaceholder",
  },
  accessibilities: {
    id: "app.components.AboutYou.accessibilities"
  },
  "accessibilities.Na": {
    id: "app.components.AboutYou.accessibilities.Na",
  },
  "accessibilities.Physical": {
    id: "app.components.AboutYou.accessibilities.Physical",
  },
  "accessibilities.Cognitive": {
    id: "app.components.AboutYou.accessibilities.Cognitive",
  },
  "accessibilities.Intellectual": {
    id: "app.components.AboutYou.accessibilities.Intellectual",
  },
  "accessibilities.Visual": {
    id: "app.components.AboutYou.accessibilities.Visual",
  },
  "accessibilities.Auditory": {
    id: "app.components.AboutYou.accessibilities.Auditory",
  },
  "accessibilities.Other": {
    id: "app.components.AboutYou.accessibilities.Other",
  },
  accessibilitiesText: {
    id: "app.components.AboutYou.accessibilitiesText"
  },
  accessibilitiesDescription: {
    id: "app.components.AboutYou.accessibilitiesDescription"
  }
})
